module.exports = __webpack_public_path__ + "img/Companycultrue-midb.84225cf1.png";